module.exports = __webpack_public_path__ + "img/epicycloid_gmt.666ed3aa.gif";